var _style, _path, _g, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _rect, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38A;}\n\t.st1{fill:#29384F;}\n\t.st2{fill:#325CA7;}\n\t.st3{fill:#AA1A18;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.3,182.9c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6S30,63.99,30,106.3 C30,148.6,64.61,182.9,107.3,182.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.1,
    y: 64.43,
    className: "st1",
    width: 11.7,
    height: 6.77
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.37,58.48h-12.84c-1.3,0-2.35,1.33-2.35,2.97c0,1.64,1.05,2.97,2.35,2.97h12.84 c1.3,0,2.35-1.33,2.35-2.97C115.72,59.81,114.67,58.48,113.37,58.48z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.88,70.03l-0.08-0.05c-1.64-1.09-3.86-0.64-4.95,1l-5.54,8.34c-1.09,1.64-0.65,3.86,1,4.95l0.08,0.05 c1.64,1.09,3.86,0.64,4.95-1l5.54-8.34C132.96,73.33,132.52,71.12,130.88,70.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.26,70.96c-1.09-1.64-3.31-2.09-4.95-1l-0.08,0.05c-1.64,1.09-2.09,3.31-1,4.95l5.54,8.34 c1.09,1.64,3.31,2.09,4.95,1l0.08-0.05c1.64-1.09,2.09-3.31,1-4.95L88.26,70.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.31,108.9v39.63h-0.03c-21.87,0-39.6-17.73-39.6-39.63H107.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.91,108.9h-39.6V69.3C129.21,69.33,146.91,87.03,146.91,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.31,69.3v39.6H67.68c0-21.87,17.73-39.6,39.6-39.6H107.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.91,108.9c0,21.9-17.7,39.6-39.6,39.63V108.9H146.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.32,82.19c0.24,0,0.51-0.06,0.74-0.15c0.98-0.41,1.44-1.53,1.03-2.51c-0.4-0.96-1.53-1.43-2.5-1.03 c-0.98,0.41-1.44,1.53-1.03,2.52C93.87,81.75,94.57,82.19,95.32,82.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.01,129.6c-0.75,0.74-0.75,1.96,0,2.71c0-0.01,0-0.01,0-0.01c0.38,0.38,0.87,0.57,1.35,0.57 c0.51,0,1-0.18,1.36-0.57c0.75-0.75,0.75-1.96,0-2.72C85.97,128.85,84.76,128.85,84.01,129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.18,135.9c-0.98-0.4-2.1,0.06-2.51,1.04c-0.4,0.98,0.06,2.1,1.04,2.5c0.24,0.11,0.49,0.15,0.74,0.15 c0.75,0,1.46-0.46,1.76-1.19C97.62,137.42,97.15,136.3,96.18,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.83,98.89c0.25,0.11,0.49,0.15,0.74,0.15c0.75,0,1.46-0.44,1.76-1.19c0.41-0.98-0.06-2.1-1.04-2.5 c-0.98-0.4-2.1,0.06-2.5,1.04C76.39,97.37,76.85,98.49,77.83,98.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.21,79.8c1.06-0.02,1.92-0.88,1.92-1.93c-0.02-1.06-0.87-1.92-1.93-1.9c-1.06,0-1.92,0.86-1.9,1.92 C105.29,78.94,106.15,79.8,107.21,79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.88,119.11c-0.98,0.41-1.44,1.53-1.04,2.52c0.32,0.74,1.03,1.18,1.78,1.18c0.24,0,0.49-0.04,0.74-0.15 c0.98-0.4,1.44-1.53,1.03-2.5C79.98,119.17,78.86,118.71,77.88,119.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.27,88.95c0.51,0,1-0.2,1.37-0.57c0.75-0.75,0.75-1.96,0-2.71c-0.75-0.75-1.96-0.74-2.71,0.02 c-0.75,0.75-0.75,1.96,0,2.7C84.3,88.77,84.79,88.95,85.27,88.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.15,109.01c0-1.06-0.87-1.92-1.93-1.92s-1.9,0.86-1.9,1.92c0,1.06,0.86,1.92,1.92,1.92 S78.15,110.06,78.15,109.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135.97,98.85c0.24,0,0.49-0.05,0.74-0.15c0.96-0.41,1.43-1.53,1.03-2.5c-0.41-0.98-1.53-1.44-2.51-1.03 c-0.97,0.4-1.44,1.53-1.03,2.5C134.5,98.41,135.22,98.85,135.97,98.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M136.75,119.05c-0.98-0.4-2.1,0.06-2.52,1.04c-0.4,0.98,0.06,2.1,1.04,2.5c0.24,0.11,0.49,0.15,0.73,0.15 c0.75,0,1.46-0.44,1.76-1.18C138.19,120.58,137.72,119.46,136.75,119.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M138.36,106.89c-1.06,0.01-1.92,0.87-1.92,1.93c0,0.03,0,0.08,0,0.11v0.01c0,1.06,0.86,1.92,1.92,1.92 c1.06,0,1.92-0.86,1.92-1.92c0-0.03,0-0.05,0-0.06c0-0.03,0-0.06,0-0.08C140.28,107.75,139.42,106.89,138.36,106.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M127.92,129.55c-0.75,0.74-0.75,1.95,0,2.7c0.38,0.39,0.87,0.57,1.36,0.57c0.49,0,0.98-0.18,1.35-0.57 c0.75-0.75,0.75-1.96,0-2.7C129.88,128.8,128.67,128.8,127.92,129.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.33,138.09c-1.06,0-1.92,0.86-1.92,1.92c0,1.06,0.86,1.92,1.92,1.92c1.06,0,1.92-0.86,1.92-1.92 C109.25,138.95,108.39,138.09,107.33,138.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.37,81.96c0.23,0.11,0.48,0.15,0.72,0.15c0.75,0,1.47-0.46,1.78-1.19c0.4-0.98-0.06-2.1-1.04-2.5 c-0.98-0.4-2.1,0.06-2.5,1.04C116.91,80.44,117.39,81.56,118.37,81.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.19,88.81c0.49,0,0.98-0.18,1.35-0.57c0.75-0.75,0.75-1.96,0-2.71c-0.77-0.75-1.98-0.74-2.72,0.01 c-0.75,0.75-0.75,1.96,0.02,2.72C128.21,88.63,128.7,88.81,129.19,88.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.48,135.87c-0.98,0.41-1.44,1.53-1.03,2.52c0.3,0.74,1.01,1.18,1.76,1.18c0.25,0,0.49-0.05,0.74-0.16 c0.98-0.4,1.44-1.52,1.04-2.5C120.58,135.93,119.46,135.47,118.48,135.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.3,85.02c0,0-4.65,20.59-4.65,23.16c0,2.57,2.08,4.65,4.65,4.65c2.57,0,4.65-2.08,4.65-4.65 C111.95,105.61,107.3,85.02,107.3,85.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.3,103.58c-2.96,0-5.37,2.4-5.37,5.36c0,2.96,2.4,5.37,5.37,5.37c2.96,0,5.37-2.4,5.37-5.37 C112.67,105.98,110.26,103.58,107.3,103.58z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.52,91.49c0-0.04,0-0.08-0.01-0.11C117.52,91.41,117.52,91.45,117.52,91.49L117.52,91.49z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.17,89.14c-0.02-0.09-0.04-0.18-0.06-0.27C117.13,88.97,117.15,89.05,117.17,89.14L117.17,89.14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.34,89.91L117.34,89.91c0.01,0.08,0.02,0.17,0.04,0.25C117.36,90.08,117.35,90,117.34,89.91z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.83,87.87c-0.02-0.07-0.05-0.13-0.07-0.2C116.78,87.74,116.81,87.81,116.83,87.87L116.83,87.87z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "115.55,99.97 115.55,99.97 115.54,99.97 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.41,94.56c0,0.02-0.01,0.04-0.01,0.07C117.4,94.6,117.4,94.58,117.41,94.56z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.09,102.05L114.09,102.05c-0.27,0.32-0.55,0.65-0.86,0.95C113.54,102.69,113.82,102.37,114.09,102.05z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.82,
    y: 101.1,
    className: "st5",
    width: 0,
    height: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.11,96.09c-0.01,0.02-0.01,0.04-0.02,0.07C117.1,96.13,117.11,96.11,117.11,96.09z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.54,93.03c0,0.01,0,0.02,0,0.03C117.54,93.05,117.54,93.04,117.54,93.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiit);
export default __webpack_public_path__ + "static/media/HIIT.527c4d940b7302c08bda0357d0912c5b.svg";
export { ForwardRef as ReactComponent };